import React from "react";
import { ListenerHelper } from "../../../../utils/ListenerHelper";

import "@styles/c-slider.scss";

interface Props {
  value: number;
  isHandleAlwaysVisible?: boolean;
  onSliderInteraction: (value: number, isChanging: boolean) => void;
  onChangingSliderInteractionStarted?: () => void;
  onSliderInteractionEnded?: (wasChanging: boolean) => void;
  secondaryValue?: number;
  className?: string;
  style?: {[key: string]: string};
}

interface State {
  isHovered: boolean;
  isDragging: boolean;
}

export class SliderComponent extends React.Component<Props, State> {

  private static HANDLE_WIDTH = 12;

  private slider: HTMLDivElement;

  constructor(props: Props) {
    super(props);
    this.state = {
      isHovered: false,
      isDragging: false
    };
  }

  render() {
    const { value, secondaryValue, className, style, isHandleAlwaysVisible } = this.props;
    return (
      <div
        ref={(element) => this.slider = element}
        className={`${className || ""} c-slider`}
        style={style}
        onMouseEnter={() => this.handleMouseEnter()}
        onMouseLeave={() => this.handleMouseLeave()}
        onMouseMove={(event) => this.handleMouseMove(event.nativeEvent)}
        onMouseDown={(event) => this.handleMouseDown(event.nativeEvent)}

        onTouchMove={(event) => this.handleTouchMove(event.nativeEvent)}
        onTouchStart={(event) => this.handleTouchStart(event.nativeEvent)}
        onTouchEnd={() => this.handleTouchEnd()}
      >
        <div className="c-slider__tracksContainer">
          <div className="c-slider__track" />
          {secondaryValue !== undefined &&
            <div
              className="c-slider__secondaryTrack"
              style={{ width: `${secondaryValue * 100}%` }}
            />
          }
          <div
            className="c-slider__primaryTrack"
            style={{ width: `${value * 100}%` }}
          />
          {(this.state.isHovered || this.state.isDragging || isHandleAlwaysVisible) &&
            <div
              className={`c-slider__handle ${this.state.isDragging ? "c-slider__handle--active" : ""}`}
              style={{ marginLeft: `${this.calculateHandleLeftMargin()}` }}
            />
          }
        </div>

      </div>
    );
  }

  private handleMouseEnter() {
    this.setState({
      isHovered: true
    });
  }

  private handleMouseLeave() {
    this.setState({
      isHovered: false
    });
    if (!this.state.isDragging) {
      this.fireInteractionEndedEvent();
    }
  }

  private handleMouseMove(event: MouseEvent) {
    this.fireInteractedEvent(event.clientX, this.state.isDragging);
  }

  private handleMouseDown(event: MouseEvent) {
    ListenerHelper.addEventListener("document", "mousemove", this.trackMouse);
    this.setState({
      isDragging: true
    });
    this.props.onChangingSliderInteractionStarted && this.props.onChangingSliderInteractionStarted();
    this.fireInteractedEvent(event.clientX, true);
    ListenerHelper.addEventListener("document", "mouseup", this.stopMouseTracking);
  }

  private trackMouse = (event: MouseEvent) => {
    this.fireInteractedEvent(event.clientX, this.state.isDragging);
  }

  private stopMouseTracking = () => {
    this.fireInteractionEndedEvent();
    this.setState({
      isDragging: false
    });
    ListenerHelper.removeEventListener("document", "mouseup", this.stopMouseTracking);
    ListenerHelper.removeEventListener("document", "mousemove", this.trackMouse);
  }

  private handleTouchMove(event: TouchEvent) {
    this.fireInteractedEvent(event.touches[0].clientX, this.state.isDragging);
  }

  private handleTouchStart(event: TouchEvent) {
    this.setState({
      isDragging: true
    });
    this.props.onChangingSliderInteractionStarted && this.props.onChangingSliderInteractionStarted();
    this.fireInteractedEvent(event.touches[0].clientX, true);
  }

  private handleTouchEnd() {
    this.setState({
      isDragging: false
    });
    this.fireInteractionEndedEvent();
  }

  private fireInteractedEvent(clientX: number, isChangingValue: boolean) {
    const progress = this.calculateProgress(clientX);
    this.props.onSliderInteraction(progress, isChangingValue);
  }

  private fireInteractionEndedEvent() {
    if (this.props.onSliderInteractionEnded) {
      this.props.onSliderInteractionEnded(this.state.isDragging);
    }
  }

  private calculateProgress(clientX: number) {
    const relativeX = clientX - this.slider.getBoundingClientRect().left;
    let progress = relativeX / (this.slider.clientWidth);
    if (progress < 0) {
      progress = 0;
    }
    if (progress > 1) {
      progress = 1;
    }
    return progress;
  }

  private calculateHandleLeftMargin() {
    if (!this.slider) {
      return 0;
    }
    return `${this.slider.clientWidth * this.props.value - SliderComponent.HANDLE_WIDTH / 2}px`;
  }

}
